import * as React from 'react';
import * as FormsyComponents from 'formsy-react-components';

import {Validations} from '../model/forms';
import * as Locale from '../model/locale';

export interface SubmitButtonProps {
    defaultValue: string;
    className?: string;
    submitting?: boolean;
    disabled?: boolean;
}

/**
 * Button class for rendering a submit button with integrated loading spinner
 * displayed when form is being submitted.
 */
export class SubmitButton extends React.Component<SubmitButtonProps, any> {
    render() {
        let {disabled, defaultValue, submitting} = this.props;
        let className = 'btn btn-primary' + (this.props.className || '');

        let inputAttrs = {
            className, disabled, defaultValue,
            formNoValidate: true, type: 'submit'
        };
        let wrapAttrs = {
            className: 'btn-submit' + (submitting ? ' loading' : '')
        };
        return (
            <div {...wrapAttrs}>
                <input {...inputAttrs}/>
                <i/>
            </div>
        );
    }
}

export interface SubscribeFormFieldsProps {
    textForKey: Function;
}

/**
 * Component containing all form fields for subscribing to a premises/unit/etc.
 */
export class SubscribeFormFields extends React.Component<SubscribeFormFieldsProps, any> {
    render() {
        let {textForKey} = this.props;

        return (
            <div>
                <FormsyComponents.Input label={textForKey(Locale.TEXT_MODAL_SUBSCRIBE_LABEL_EMAIL)}
                                        name="email"
                                        placeholder="me@sample.com"
                                        validations={Validations.email.validator}
                                        validationErrors={Validations.email.messages(textForKey)}/>

                <FormsyComponents.Input label={textForKey(Locale.TEXT_MODAL_SUBSCRIBE_LABEL_MOBILE)}
                                        name="mobile"
                                        placeholder="+353 01 1234567"
                                        validations={Validations.mobile.validator}
                                        validationErrors={Validations.mobile.messages(textForKey)}/>
            </div>
        );
    }
}
